module.exports = __webpack_public_path__ + "static/media/delete.bbd57609.svg";